/**
 * @generated SignedSource<<428634cb8eb26d6fcca81f4cae44f322>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSharedCarouselItemTile_user$data = {
  readonly canShowSellerName: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"FavoritesItemProvider_user">;
  readonly " $fragmentType": "PdpRespSharedCarouselItemTile_user";
};
export type PdpRespSharedCarouselItemTile_user$key = {
  readonly " $data"?: PdpRespSharedCarouselItemTile_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSharedCarouselItemTile_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSharedCarouselItemTile_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canShowSellerName",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "FavoritesItemProvider_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "b238210c6bdd4b71e3efb08c455086ee";

export default node;
